import api from './api';

/**
 * Notification client.
 *
 *   Inbox:       list/read/unread-count/mark-read/mark-all-read
 *   Preferences: per-channel enable/disable + optional event_types filter
 *   Templates:   admin-only CRUD for `notification_templates` rows used by
 *                the event consumer when rendering per-channel subject/body.
 */
const notificationService = {
  getNotifications: (params) => api.get('/notifications', { params }),
  markAsRead: (id) => api.put(`/notifications/${id}/read`),
  markAllAsRead: () => api.put('/notifications/mark-all-read'),
  getUnreadCount: () => api.get('/notifications/unread-count'),

  // Preferences (self-service)
  getPreferences: () => api.get('/notifications/preferences'),
  updatePreferences: (data) => api.put('/notifications/preferences', data),

  // Phase 18d — discover the server's event-type registry so the
  // preferences UI isn't hardcoded to a stale list.
  listEventTypes: () => api.get('/notifications/preferences/event-types'),

  // Phase 18h — per-user language / timezone / digest opt-in.
  // Profile is created lazily on first GET so every user has
  // a stable shape to render.
  getProfile: () => api.get('/notifications/preferences/profile'),
  updateProfile: (data) => api.patch('/notifications/preferences/profile', data),
  listLanguages: () => api.get('/notifications/preferences/languages'),

  // Phase 18f — soft-delete from the inbox.
  deleteOne: (id) => api.delete(`/notifications/${id}`),
  deleteBulk: (ids) => api.post('/notifications/bulk-delete', { ids }),

  // Templates (admin-only)
  listTemplates: (params = {}) => api.get('/notifications/templates', { params }),
  getTemplate: (id) => api.get(`/notifications/templates/${id}`),
  updateTemplate: (id, data) => api.patch(`/notifications/templates/${id}`, data),
};

export default notificationService;
